import React from 'react';
import './Footer.css';
const Footer = () => {
    return (
        <div className="footer">
            <p> © copy right version 4.4.1 2021.</p>
        </div>
    );
};

export default Footer;